<template>
  <app-page-title :color="color">
    <template #pageTitleLeft>
      <h1>
        <slot></slot>
      </h1>
    </template>
  </app-page-title>
</template>

<script>
  import AppPageTitle from '@sections/PageTitle'

  export default {
    props: {
      color: {
        type: String,
        default: 'leaf'
      }
    },
    components: {
      AppPageTitle
    }
  }
</script>
